<template>
    <div>
        <v-row justify="center" class="bg-color-teal-900">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="body-text text-white mt-4">
                            <p class="text-h4 font-weight-light">
                                <LanguagePlaceholder is-html
                                    default-text="Redemption Balance Report" />
                            </p>
                            <br />
                            <p>
                                <b>WHAT is this report: </b>
                                This report shows the rewards value earned by your partners in a quarter, how much they have redeemed (converted rewards to E-vouchers) and what their left over balance is. This is a live report.
                                <br /><br />
                                <b>HOW do you use it: </b>
                                Use this report strictly in the open redemption period to drive partners to spend with you. Once a partner has a zero balance, they will no longer appear on this report.
                            </p>
                            <PleaseNote></PleaseNote>
                        </div>
                    </v-container>

                    <v-row class="my-2">
                        <v-col cols="12" sm="6" md="4">
                            <div>
                                <v-select class="text-white" v-model="selectedQuarter"
                                    :items="quarters" variant="outlined"
                                    aria-label="Select Incentive Period">
                                    <template v-slot:label>
                                        <LanguagePlaceholder is-html default-text="Select Incentive Period" />
                                    </template>
                                </v-select>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <div>
                                <v-select clearable :items="countries" return-object v-if="canSelectCountry"
                                    v-model="selectedCountry" class="text-white" item-title="country"
                                    item-value="country" variant="outlined"
                                    aria-label="Select Location">
                                    <template v-slot:label>
                                        <LanguagePlaceholder is-html default-text="Select Location" />
                                    </template>
                                </v-select>
                            </div>
                        </v-col>
                    </v-row>
                </v-row>
                <v-row class="my-2"> 
                            <div>
                                <v-btn @click="clickSubmit" color="white" variant="outlined"><LanguagePlaceholder default-text="Submit" /></v-btn>
                            </div>
                    </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row justify="center" style="background-color: #ffffff;" class="pb-6">
            <v-toolbar density="compact" color="#00796B">
                <v-spacer></v-spacer>
                <v-btn prepend-icon="mdi-download" @click="downloadFile" aria-label="Download Report"></v-btn>
            </v-toolbar>
            <v-container>
                <v-card flat>
                    <v-text-field v-model="searchString" label="Filter" prepend-inner-icon="mdi-filter-outline"
                        variant="outlined" hide-details single-line></v-text-field>

                    <v-data-table items-per-page="50" :search="searchString" :headers="headers" :items="reportData"
                        class="v-data-table">
                        <template v-slot:item.balance="{ item }">
                            {{ $filters.currencyUSD(item.balance) }}
                        </template>
                        <template v-slot:item.openingBalance="{ item }">
                            {{ $filters.currencyUSD(item.openingBalance) }}
                        </template>
                        <template v-slot:item.redeemed="{ item }">
                            {{ $filters.currencyUSD(item.redeemed) }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-container>
        </v-row>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useSystemStore } from '@/stores/system'
import { useRegistrationStore } from '@/stores/registration'
import { useExcelStore } from '@/stores/excel'
import PleaseNote from '@/components/PleaseNote.vue'

const systemStore = useSystemStore()
const registrationStore = useRegistrationStore()
const excelStore = useExcelStore()

const countries = ref([])
const distributors = ref([])
const reportData = ref([])
const searchString = ref('')

const quarters = ref([])
const selectedQuarter = ref('')
const selectedDistributor = ref(null)
const selectedCountry = ref('')

const headers = [
    { title: 'Partner Name', value: 'partnerName', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Partner Id', value: 'partnerAffinityId', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Location', value: 'country', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Opening Balance', value: 'openingBalance', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Redeemed', value: 'redeemed', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Balance', value: 'balance', sortable: true, headerProps: { class: 'header-style' } }
]

const canSelectCountry = computed(() => {
    if (systemStore.userDetail.userType.trim() === 'Dell'
        || systemStore.userDetail.userType.trim() === 'TP'
        || systemStore.userDetail.userType.trim() === 'PAM'
        || systemStore.userDetail.userType.trim() === 'Dell Marketing'
        || systemStore.userDetail.userType.trim() === 'TIC_Admin'
    ) {
        return true
    } else {
        return false
    }

})

onMounted(() => {
    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentRedemptionQuarter === true || q.previousRedemptionQuarters === true)
                .map(q => q.quarter)

            selectedQuarter.value = result.quarters.find(q => q.currentRedemptionQuarter === true)?.quarter
        }
    }).catch(error => {
        console.log('recalculateLocalValue', error)
    })

    registrationStore.GetEMEACountries().then(result => {
        countries.value = result.countries
    }).catch(error => {
        console.log('disti dashb get countries', error)
    })

    // getDistributors()
})

const downloadFile1 = () => {
    systemStore.downloadCsvFile(reportData.value, 'redemptionReport.csv')
}

const downloadFile = () => {
    if (reportData.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocument(reportData.value, 'DistributorRedemptionDocument').catch(error => {
        console.log('Generate In Memory Excel Document - DistributorRedemptionDocument', error)
    })
}

const clickSubmit = () => {
    getReportData()
}

const clickClearDistributor = () => {
    selectedDistributor.value = null
}

// const getDistributors = () => {
//     systemStore.getDistributorRedemptionDistributors(selectedQuarter.value).then(result => {
//         distributors.value = result.reportData
//         if (distributors.value.length > 0) {
//             selectedDistributor.value = distributors.value[0]
//         }
//     })
// }

const getReportData = () => {
    var country = selectedCountry.value == null || selectedCountry.value == undefined || selectedCountry.value == '' ? '' : selectedCountry.value.country
    var distiId = selectedDistributor.value == null ? 0 : selectedDistributor.value.distiId

    systemStore.getDistributorRedemptionData(selectedQuarter.value, distiId, country).then(result => {
        reportData.value = result.reportData
    }).catch(error => {
        console.log('distributor redemption data, get data', error)
    })
}

</script>

<style>
.header-style {

    background-color: #004D40 !important;
    color: white;
}

.header-style:hover {
    color: white !important;
}

.v-data-table tbody tr:nth-child(even) {
    background-color: #e0e6ec;
    color: #202520;
}

.v-data-table tbody tr:nth-child(odd) {
    background-color: whitesmoke;
    color: #202520;
}
</style>